// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"27f3aab6","681":"c8de94c3"}[chunkId] + ".chunk.css";
};